/*!
 * Vante North · detalles tecnológicos (JavaScript sin dependencias; los estilos están en vn-brand.css,
 * bloque "Efectos tecnológicos")
 *
 * - Rejilla linterna (solo con ratón, secciones claras): una rejilla de puntos casi invisible que se revela alrededor
 *   del cursor. La máscara radial es fija; lo que se mueve es la capa (transform) y la rejilla de dentro va en sentido
 *   contrario, así los puntos no se deslizan.
 * - Haz de borde: una luz recorre el borde de la tarjeta de portada, la tabla comparativa, el pack 3x2 y los botones principales
 *   (gradiente cónico que gira con transform dentro de un anillo de 1-2 px hecho con máscara). Solo gira mientras se ve.
 * - Descifrado: los antetítulos cortos (.vn-eyebrow de 18 letras o menos) pasan por caracteres al azar antes de fijarse
 *   la primera vez que aparecen. El texto real sigue en el DOM para lectores de pantalla y cada letra tiene su ancho
 *   fijado (no cambia el ancho). Al terminar, el antetítulo queda exactamente como estaba.
 *
 * Se carga solo con el ajuste "Animaciones avanzadas" y no hace nada si se pide "reducir movimiento".
 * Editor de Shopify: se vuelve a aplicar al recargar una sección. Vista previa: también al cambiar de página.
 */
(function () {
  'use strict';
  if (window.vnTecno) return;
  window.vnTecno = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !document.body || !document.body.hasAttribute('data-vn-motion')) return;
  var fino = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hayIO = 'IntersectionObserver' in window, hayRO = 'ResizeObserver' in window;

  function seVe(el) { return !!el.getClientRects().length; }

  // ---------------------------------------------------------------- rejilla linterna
  var LINTERNA = '.vn-card-section, .vn-amb, .vn-brand, .vn-hl, .vn-compare, .vn-box, .vn-specs, .vn-faq, .vn-service, ' +
    '.vn-dsp, .vn-statement, .vn-ideas, .vn-video-section, .vn-reviews, .vn-features, .vn-uses, .vn-positions';
  function esClaro(el) {
    var m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
    if (!m || (m.length > 3 && +m[3] === 0)) return false;
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255 > 0.6;
  }
  function linternas(scope) {
    if (!fino) return;
    scope.querySelectorAll(LINTERNA).forEach(function (sec) {
      if (sec.dataset.vnLinterna || !seVe(sec)) return; // en una página oculta de la vista previa: cuando se vea
      if (sec.querySelector(':scope > .vn-campo')) { sec.dataset.vnLinterna = 'no'; return; }
      if (!esClaro(sec)) { sec.dataset.vnLinterna = 'no'; return; }
      sec.dataset.vnLinterna = '1';
      sec.classList.add('vn-linterna-host');
      var capa = document.createElement('div');
      capa.className = 'vn-linterna';
      capa.setAttribute('aria-hidden', 'true');
      capa.innerHTML = '<div class="vn-linterna__foco"><div class="vn-linterna__rejilla"></div></div>';
      sec.insertBefore(capa, sec.firstChild);
    });
  }
  var activa = null, ratonX = 0, ratonY = 0, pendiente = false;
  function capaDe(sec) { return sec && sec.querySelector(':scope > .vn-linterna'); }
  function encender(sec) {
    var capa = capaDe(sec);
    if (!capa) return;
    var rejilla = capa.firstChild.firstChild;
    rejilla.style.width = sec.offsetWidth + 'px';
    rejilla.style.height = sec.offsetHeight + 'px';
    capa.classList.add('is-on');
  }
  function apagar(sec) { var capa = capaDe(sec); if (capa) capa.classList.remove('is-on'); }
  function moverLinterna() {
    pendiente = false;
    var capa = capaDe(activa);
    if (!capa) return;
    var foco = capa.firstChild, rejilla = foco.firstChild;
    var r = capa.getBoundingClientRect(), mitad = foco.offsetWidth / 2;
    var x = Math.round(ratonX - r.left), y = Math.round(ratonY - r.top);
    foco.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    rejilla.style.transform = 'translate3d(' + (mitad - x) + 'px,' + (mitad - y) + 'px,0)';
  }
  function pedirLinterna() { if (!pendiente && activa) { pendiente = true; requestAnimationFrame(moverLinterna); } }
  if (fino) {
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !e.target.closest) return;
      var sec = e.target.closest('.vn-linterna-host');
      if (sec !== activa) {
        if (activa) apagar(activa);
        activa = sec;
        if (sec) { ratonX = e.clientX; ratonY = e.clientY; moverLinterna(); encender(sec); }
      }
      ratonX = e.clientX; ratonY = e.clientY;
      pedirLinterna();
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (!e.relatedTarget && activa) { apagar(activa); activa = null; } // el ratón sale de la ventana
    });
    window.addEventListener('scroll', pedirLinterna, { passive: true });
  }

  // ---------------------------------------------------------------- haz de borde
  var HAZ = '.vn-card, .vn-compare__table, .vn-hero .button:not(.button--secondary), .vn-product__submit, .vn-pack--destacado';
  var ioHaz = hayIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('vn-haz-on', e.isIntersecting); });
  }) : null;
  var roHaz = hayRO ? new ResizeObserver(function (es) { es.forEach(function (e) { medirHaz(e.target); }); }) : null;
  function medirHaz(el) {
    var d = Math.ceil(Math.hypot(el.offsetWidth, el.offsetHeight)) + 2; // el cuadrado que gira cubre la diagonal
    el.style.setProperty('--vn-haz-d', d + 'px');
  }
  function haces(scope) {
    if (!ioHaz || !roHaz) return;
    scope.querySelectorAll(HAZ).forEach(function (el) {
      if (el.querySelector(':scope > .vn-haz')) return;
      el.classList.add('vn-haz-host');
      var s = document.createElement('span');
      s.className = 'vn-haz';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<span class="vn-haz__luz"></span>';
      // Botones: al final, porque Dawn usa el primer <span> del botón para su texto (product-form.js, toggleAddButton).
      // Tarjeta y tabla: al principio, para no cambiar los :last-child de las filas.
      if (el.matches('button, .button')) el.appendChild(s); else el.insertBefore(s, el.firstChild);
      medirHaz(el);
      ioHaz.observe(el); roHaz.observe(el);
    });
  }

  // ---------------------------------------------------------------- descifrado de antetítulos
  var SIGNOS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&+/<>=';
  function azar() { return SIGNOS.charAt(Math.floor(Math.random() * SIGNOS.length)); }
  var ioCifra = hayIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      ioCifra.unobserve(e.target);
      descifrar(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  function cifras(scope) {
    if (!ioCifra) return;
    scope.querySelectorAll('.vn-eyebrow').forEach(function (el) {
      if (el.dataset.vnCifra || el.closest('.vn-hero') || el.children.length) return;
      var t = el.textContent.trim();
      if (!t || t.length > 18) return;
      el.dataset.vnCifra = '1';
      ioCifra.observe(el);
    });
  }
  function descifrar(el) {
    var nodo = el.firstChild;
    if (!nodo || nodo.nodeType !== 3 || el.childNodes.length !== 1 || !seVe(el)) return;
    var texto = nodo.nodeValue;
    // Ancho real de cada letra (con mayúsculas y espaciado) para fijarlo durante el efecto
    var rango = document.createRange(), anchos = [];
    for (var i = 0; i < texto.length; i++) {
      rango.setStart(nodo, i); rango.setEnd(nodo, i + 1);
      anchos.push(rango.getBoundingClientRect().width);
    }
    var lector = document.createElement('span');
    lector.className = 'vn-cifra-sr';
    lector.textContent = texto;
    var vista = document.createElement('span');
    vista.className = 'vn-cifra';
    vista.setAttribute('aria-hidden', 'true');
    var letras = [];
    for (var j = 0; j < texto.length; j++) {
      var s = document.createElement('span');
      s.style.width = anchos[j].toFixed(3) + 'px';
      var espacio = /\s/.test(texto.charAt(j));
      s.textContent = espacio ? ' ' : azar();
      vista.appendChild(s);
      if (!espacio) letras.push({ el: s, real: texto.charAt(j), fija: 0 });
    }
    el.replaceChild(vista, nodo);
    el.insertBefore(lector, vista);
    var n = letras.length, inicio = performance.now(), ultimo = 0;
    letras.forEach(function (l, k) { l.fija = 220 + (n > 1 ? k / (n - 1) : 0) * 520; });
    function paso(ahora) {
      if (!el.isConnected) return;
      var t = ahora - inicio, quedan = 0, cambia = ahora - ultimo > 50;
      if (cambia) ultimo = ahora;
      letras.forEach(function (l) {
        if (t >= l.fija) { if (l.el.textContent !== l.real) l.el.textContent = l.real; return; }
        quedan++;
        if (cambia) l.el.textContent = azar();
      });
      if (quedan) { requestAnimationFrame(paso); return; }
      el.textContent = texto; // vuelve al texto de siempre (un solo nodo de texto)
    }
    requestAnimationFrame(paso);
  }

  // ---------------------------------------------------------------- arranque
  function iniciar(scope) {
    scope = scope || document;
    linternas(scope); haces(scope); cifras(scope);
  }
  function arrancar() {
    iniciar(document);
    window.addEventListener('hashchange', function () { setTimeout(function () { iniciar(document); }, 90); });
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
